import React, { lazy } from 'react';
import { Redirect } from 'react-router';

import allUserGroups from 'enum/userGroups';
import UserStore from 'stores/UserStore';
import routeDefinitions from 'enum/routeDefinitions';


const FanClubsPage = lazy(() => import('./Page'));

const FanClubs = () => {
  const isPageActive = UserStore.hasCF(allUserGroups.FANCLUB_DIRECTORY);

  if (!isPageActive) {
    return <Redirect to={routeDefinitions.pageNotFound} />;
  }

  return <FanClubsPage />;
};

export default FanClubs;
